<template>
    <Head title="Connexion" />

    <AuthLayout title="Ravi de vous revoir.">
        <div>
            <JetValidationErrors class="mb-4" />

            <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                {{ status }}
            </div>
        </div>
        <form @submit.prevent="submit">
            <div class="space-y-4">
                <div>
                    <ul class="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar">
                        <li class="pb-3 mr-6 last:mr-0 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                            <a class="whitespace-nowrap cursor-pointer uppercase" @click.prevent="currentTab = 1"
                                :class="currentTab === 1 ? 'text-sky font-semibold' : 'text-gray-500 hover:text-gray-600'"
                            >Adresse mail</a>
                        </li>
                        <li class="pb-3 mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
                            <a class="whitespace-nowrap cursor-pointer uppercase" @click.prevent="currentTab = 2"
                                :class="currentTab === 2 ? 'text-sky font-semibold' : 'text-gray-500 hover:text-gray-600'"
                            >Numéro de téléphone</a>
                        </li>
                    </ul>
                </div>
                <div v-if="currentTab === 1">
                    <JetLabel for="email" value="Adresse mail:" />
                    <JetInput id="email" type="email" autocomplete="off" autofocus
                        v-model="form.email" placeholder="Entrer votre adresse mail"
                    />
                </div>
                <div v-if="currentTab === 2">
                    <JetLabel for="phone" value="Numéro de téléphone:" />
                    <vue-tel-input
                        @input="phoneInput"
                        :defaultCountry="form.country_code"
                        :value="form.phone"
                    />
                </div>
                <div>
                    <JetLabel for="password" value="Mot de passe:" />
                    <JetInput id="password" type="password" autocomplete="off" required
                        v-model="form.password" placeholder="Entrer votre mot de passe"
                    />
                </div>
            </div>
            <div class="mt-4 mr-1">
                <label class="flex items-center">
                    <input type="checkbox" class="form-checkbox">
                    <span class="text-sm ml-2">Je reste connecté</span>
                </label>
            </div>
            <div class="flex items-center justify-between mt-6">
                <div class="mr-1">
                    <Link v-if="canResetPassword" :href="route('password.request')"
                        class="text-sm underline hover:no-underline hover:text-sky"
                    >Mot de passe oublié ?</Link>
                </div>

                <BotiButton :loader="form.processing" :disabled="form.processing"
                    @click="submit"  color="sky"
                    :class="{ 'opacity-25': form.processing }" text="Connexion"
                >
                    <svg v-if="form.processing" class="animate-spin w-4 h-4 fill-current shrink-0" viewBox="0 0 16 16">
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"></path>
                    </svg>
                    <template #icon>
                        <i class="fad fa-sign-in ml-1"></i>
                    </template>
                </BotiButton>
            </div>
        </form>
        <!-- Footer -->
        <div class="pt-5 mt-6 border-t border-gray-200" v-if="canRegister">
            <div class="text-sm">
                Vous n'avez pas de compte ?
                <Link :href="route('register')" class="font-medium text-sky hover:text-sky-400">
                    Rejoignez nous
                </Link>
            </div>
        </div>
    </AuthLayout>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetLabel from '@/Jetstream/Label'
    import JetInput from '@/Jetstream/Input'
    import BotiButton from '@/Components/Button'
    import AuthLayout from '@/Layouts/AuthLayout.vue'
    import JetInputError from '@/Jetstream/InputError'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetLabel,
            JetInput,
            BotiButton,
            AuthLayout,
            JetInputError,
            JetValidationErrors
        },

        props: {
            status: String,
            canRegister: Boolean,
            canResetPassword: Boolean
        },

        data() {
            return {
                currentTab: 1,
                form: this.$inertia.form({
                    email: '',
                    password: '',
                    remember: false,
                    phone: null,
                    dial_code: null,
                    country_code: null
                })
            }
        },

        methods: {
            phoneInput(number, phoneObject) {
                if(number !== undefined && phoneObject !== undefined) {
                    this.form.phone =  number ? number : ''
                    this.form.dial_code = phoneObject ? phoneObject.country.dialCode : null
                    this.form.country_code = phoneObject ? phoneObject.country.iso2 : null
                }
            },

            submit() {
                this.form.transform(data => ({
                    ... data,
                    remember: this.form.remember ? 'on' : '',
                    type: this.currentTab,
                    identifier: this.currentTab === 1 ? this.form.email : this.form.phone
                }))
                .post(this.route('login'), {
                    onFinish: () => this.form.reset('password')
                })
            }
        }
    })
</script>
